import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { fetchCompanyTypeList } from '../../shared/store/lookupSlice';
import CarrierManagementLeftPanel from "./LeftPanel/CarrierManagementPanel";
import CarrierDetailsPanel from "./Detail/CarrierDetailsPanel";
import { Row, Col, Button } from "react-bootstrap";
import { AbilityContext } from '../../shared/abilities/AbilityContext';
import * as constant from '../../shared/util/constant';

const CarrierManagementMain = () => {
    const ability = useContext(AbilityContext);
    const canCreate = ability.can('create', constant.MaintenanceSubject, constant.MaintenanceScreenPrivileges.Carrier_Management);
    const canUpdate = ability.can('update', constant.MaintenanceSubject, constant.MaintenanceScreenPrivileges.Carrier_Management);
    const canDelete = ability.can('delete', constant.MaintenanceSubject, constant.MaintenanceScreenPrivileges.Carrier_Management);
    const [selectedCarrierId, setSelectedCarrierId] = useState<string | null>(null);
    const [selectedParentId, setSelectedParentId] = useState<string | null>(null);
    const [selectedParentDetail, setSelectedParentDetail] = useState<any | null>(null);
    const [refreshLeftPanel, setRefreshLeftPanel] = useState(0);
    const [panelMode, setPanelMode] = useState<'none' | 'new' | 'view' | 'edit'>('none');
    const dispatch = useDispatch();

    useEffect(() => {
        setSelectedCarrierId(null);
        setPanelMode('none');
        dispatch(fetchCompanyTypeList());
    }, [dispatch]);

    const handleSelectCarrier = (id: string | null, parentDetail?: any) => {
        setSelectedCarrierId(id);
        setPanelMode(id ? 'view' : 'none');
        if (parentDetail) setSelectedParentDetail(parentDetail);
    };


    const handleAddNew = () => {
        setSelectedCarrierId(null);
        setPanelMode('new');
    };


    const handleAddParentCompany = () => {
        setSelectedCarrierId(null);
        setSelectedParentId(null);
        setPanelMode('new');
    };



    const handleCarrierCreated = (id: string, created?: any) => {
        setSelectedCarrierId(id);
        if (created && created.parentCompanyId) {
            setSelectedParentId(created.parentCompanyId);
        } else if (selectedParentDetail && selectedParentDetail.id) {
            setSelectedParentId(selectedParentDetail.id);
        }
        setRefreshLeftPanel(r => r + 1);
        setPanelMode('view');
    };

    // Clear selection if carrier is not present after refresh
    const handleLeftPanelRefresh = (carriers: any[]) => {
        if (selectedCarrierId && !carriers.some(c => c.id === selectedCarrierId)) {
            setSelectedCarrierId(null);
            setPanelMode('none');
        }
    };


    const handleEdit = () => {
        setPanelMode('edit');
    };

    return (
        <>
            <Row>
                <Col md={4}>
                    <CarrierManagementLeftPanel
                        onSelectCarrier={handleSelectCarrier}
                        selectedCarrierId={selectedCarrierId}
                        refresh={refreshLeftPanel}
                        onParentSelect={setSelectedParentId}
                        onAddParentCompany={handleAddParentCompany}
                        onRefreshCarriers={handleLeftPanelRefresh}
                        canCreate={canCreate}
                    />
                </Col>
                <Col md={8}>
                    <CarrierDetailsPanel
                        mode={panelMode}
                        carrierId={selectedCarrierId || undefined}
                        parentCompanyId={selectedParentId || undefined}
                        parentDetail={selectedParentDetail}
                        onRefreshLeftPanel={() => setRefreshLeftPanel(r => r + 1)}
                        onCarrierCreated={handleCarrierCreated}
                        onAddNew={handleAddNew}
                        onEdit={handleEdit}
                        onCancel={() => {
                            if (panelMode === 'new') {
                                setPanelMode('none');
                            } else if (panelMode === 'edit') {
                                setPanelMode('view');
                            }
                        }}
                        onSaveSuccess={() => setPanelMode('view')}
                        canCreate={canCreate}
                        canUpdate={canUpdate}
                        canDelete={canDelete}
                    />
                </Col>
            </Row>
        </>
    );
};

export default CarrierManagementMain;